

export const company = "shapeshop";


/* two container use : */
// export const baseURL = "http://localhost:8080/";
// export const baseURL = "http://localhost:8080/";

/* 'docker compose up' use : */
// export const baseURL = "http://localhost:8081/";

/* 'azure' use : */
// export const baseURL = "https://alpenhof3.netlify.app/";
export const baseURL = "https://shape-shop-app.happywave-c1a7da5f.westeurope.azurecontainerapps.io/";


// switches -


// export const company = "alpenhof";
//
//
// /* two container use : */
// // export const baseURL = "http://localhost:8080/";
//
// /* 'docker compose up' use : */
// export const baseURL = "http://localhost:8081/";

/* 'azure' use : */
// export const baseURL = "https://shape-shop-app.happywave-c1a7da5f.westeurope.azurecontainerapps.io/";


// switches -

// persist in local storage
export const CACHE = true;

// mock mode
export const MOCK_MODE = false;